import React, { useState, useEffect, useRef, Fragment } from "react";
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import MultipleDropdown from '../../core/controls/components/checkautocomplete';
import { GetData, PostData, PutData } from "../../core/controls/helpers/requests";
import { createRequest, requestApi } from '../../core/controls/helpers/rest';
import { snackbarMessage } from '../../core/actions';
import { getEnvVariable } from "../../modules/environmentalList";
import CFormCheckbox from '../../core/modules/form/cformcheckbox';
import FormHeader from '../../core/modules/form/cformheader';
import Template from '../../core/modules/template/template';

const multitransformProps = {
  transformProps: {
    label: "name",
    value: "id"
  }
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

const NSTemplate = (props) => {
  const [tabValue, setTabValue] = useState(0);
  const [isGrouped, setIsGrouped] = useState("N");
  const [internalTemplateId, setInternalTemplateId] = useState(0);
  const [externalTemplateId, setExternalTemplateId] = useState(0);
  const [fields, setFields] = useState([]);
  const [submoduleselectedtables, setSubmoduleselectedtables] = useState('');
  const [submoduleselectedtablesresults, setSubmoduleselectedtablesresults] = useState([]);

  // Determine if updating an existing record
  const updateRecord = props.dataItem ? (props.dataItem.ID ? true : false) : false;

  const transformProps = {
    "Y": true,
    "N": false,
    true: "Y",
    false: "N"
  };

  // Initialize resultsRef with a default two-item structure.
  const resultsRef = useRef([
    { IsGrouped: "N", TemplateId: 0, UseType: "I", NotificationSettingId: props.dataItem ? props.dataItem.ID : props.match.params.routeid },
    { IsGrouped: "N", TemplateId: 0, UseType: "E", NotificationSettingId: props.dataItem ? props.dataItem.ID : props.match.params.routeid }
  ]);

  const url1 = props.dataItem
    ? `${getEnvVariable('Notification')}/api/NotificationTemplates/EventNotificationtemplate/${props.dataItem.ID}`
    : `${getEnvVariable('Notification')}/api/NotificationTemplates/EventNotificationtemplate/${props.match.params.routeid}`;

  const url2 = props.dataItem
    ? `${getEnvVariable('Notification')}/api/NotificationTemplates/SaveEventNotificationTemplate/${props.dataItem.ID}`
    : `${getEnvVariable('Notification')}/api/NotificationTemplates/SaveEventNotificationTemplate/${props.match.params.routeid}`;

  // Reference for the Template component
  const templateFormRef = useRef();

  const fetchData = (requestType, url, queryParam, body) => {
    const queryStr = queryParam != null ? `${url}?${queryParam}` : url;
    if (requestType === "GET") {
      return GetData(queryStr);
    } else if (requestType === "POST") {
      return PostData(queryStr, body);
    } else if (requestType === "PUT") {
      return PutData(queryStr, body);
    }
  };

  const getBusiessRules = (sidebarItems) => {
    if (updateRecord) {
      let sideUrl = '';
      if (sidebarItems && sidebarItems !== '') {
        const items = sidebarItems.split(',');
        items.forEach(each => {
          const found = props.extraProps.sideBarTablesRecords.find(item => item.value.toString() === each);
          if (found) {
            sideUrl += `&SideBarItems=${found.name}`;
          }
        });
      }
      const read = [
        {
          url: `${getEnvVariable('Sidebar')}/api/BusinessRules/Builder/Template?SitePermitTypeId=${props.extraProps.SitePermitTypeId}${sideUrl}`,
          type: 'get'
        },
      ];
      Promise.all(read.map(each => requestApi(createRequest(each, {}))))
        .then(res => {
          let [fieldsData] = res;
          setFields(fieldsData.map(item => {
            item.name = item.name.replace(" ", "");
            return item;
          }));
        })
        .catch(x => console.log(x));
    }
  };

  useEffect(() => {
    if (updateRecord) {
      fetchData('GET', url1, null, null)
        .then(response => {
          if (response) {
            console.log('ok response', response);
            let data = response;
            if (data && data.length > 0) {
              // Build a default structure for two records
              let defaultResults = [
                { IsGrouped: "N", TemplateId: 0, UseType: "I", NotificationSettingId: props.dataItem ? props.dataItem.ID : props.match.params.routeid },
                { IsGrouped: "N", TemplateId: 0, UseType: "E", NotificationSettingId: props.dataItem ? props.dataItem.ID : props.match.params.routeid }
              ];
              // Merge the fetched record(s) based on UseType.
              data.forEach(item => {
                if (item.UseType === "I") {
                  defaultResults[0] = { ...defaultResults[0], ...item };
                } else if (item.UseType === "E") {
                  defaultResults[1] = { ...defaultResults[1], ...item };
                }
              });
              resultsRef.current = defaultResults;
              setInternalTemplateId(defaultResults[0]?.TemplateId ?? 0);
              setIsGrouped(defaultResults[0]?.IsGrouped ?? "N");
              setExternalTemplateId(defaultResults[1]?.TemplateId ?? 0);
              getBusiessRules(props.extraProps.submoduleselectedtables);
            }
            return response;
          } else {
            throw response.json();
          }
        })
        .catch(x => console.log(x));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleIsGroupChange = (event) => {
    const value = transformProps[event.target.checked] || event.target.value;
    setIsGrouped(value);
    resultsRef.current[0].IsGrouped = value;
  };

  const handleInternalTemplateId = (data) => {
    if (internalTemplateId !== data.id) {
      setInternalTemplateId(data.id);
      resultsRef.current[0].TemplateId = data.id;
      handleSave();
    }
  };

  const handleExternalTemplateId = (data) => {
    if (externalTemplateId !== data.id) {
      setExternalTemplateId(data.id);
      resultsRef.current[1].TemplateId = data.id;
      handleSave();
    }
  };

  const handleSaveWithTemplate = () => {
    console.log(resultsRef.current);
    if (templateFormRef.current && templateFormRef.current.saveTemplate) {
      templateFormRef.current.saveTemplate();
    }
  };

  const handleSave = () => {
    console.log(resultsRef.current);
    fetchData('PUT', url2, null, resultsRef.current)
      .then(response => {
        if (response) {
          return 'success';
        }
      })
      .then(data => {
        // Optionally handle returned data here
      })
      .catch(err => console.log(err));
  };

  const handleChange = (event, value) => {
    setTabValue(value === 0 ? 0 : 1);
  };

  const handleMultidropdown = (tags) => {
    const resultdata = tags.target.value;
    const resultdatasplit = resultdata.split(",");
    const selectedRecords = props.extraProps.sideBarTablesRecords.filter(a =>
      resultdatasplit.includes(a.id.toString())
    );
    setSubmoduleselectedtables(resultdata);
    setSubmoduleselectedtablesresults(selectedRecords);
    getBusiessRules(resultdata);
  };

  const noExtNotification = ["INTERNAL_STATUS_TIMER_NOTIFICATION", "APPEAL_STATUS_TIMER_NOTIFICATION", "EXTERNAL_STATUS_TIMER_NOTIFICATION"];
  const hasExternalNotify = (!props.extraProps.hideexternal &&
                            props.extraProps.NotificationType !== 'SCHEDULED_NOTIFICATION' &&
                            !noExtNotification.includes(props.extraProps.EventOn));
  const templabel = hasExternalNotify ? "Internal" : "Internal";

  return (
    <Fragment>
      <Paper>
        <FormHeader handleSave={handleSaveWithTemplate} savebutton={true} designprops={true} />
        <Tabs
          value={tabValue}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label={templabel} />
          {hasExternalNotify && <Tab label="External" />}
        </Tabs>
        <TabPanel className=" col-sm-12" value={tabValue} index={0}>
          <Typography>
            {(props.extraProps.NotificationType === 'EVENT_NOTIFICATION' ||
              props.extraProps.NotificationType === 'BUSINESS_RULES_NOTIFICATION') && (
              <div className="mt-2 ps-3">
                <CFormCheckbox
                  value={isGrouped}
                  handleFieldChange={handleIsGroupChange}
                  name="IsGrouped"
                  transformProps={transformProps}
                  label="Group Notifications"
                  checked="IsGrouped"
                />
              </div>
            )}
            {(props.extraProps.NotificationType === 'EVENT_NOTIFICATION' ||
              props.extraProps.NotificationType === 'BUSINESS_RULES_NOTIFICATION') && (
              <div className="mt-2 ps-3">
                <MultipleDropdown
                  label="Select table(s)"
                  name="SideBarTables"
                  items={props.extraProps.sideBarTablesRecords}
                  handleFieldValue={handleMultidropdown}
                  value={submoduleselectedtables || ''}
                  extraProps={multitransformProps}
                  ismulti={true}
                />
              </div>
            )}
            <Template
              ref={templateFormRef}
              moduleId={props.extraProps.SubModuleKey}
              sitePermitTypeId={props.extraProps.SitePermitTypeId}
              handleTemplateId={handleInternalTemplateId}
              templateId={internalTemplateId}
              noswap={true}
              parentid={props.dataItem ? props.dataItem.ID : null}
              isadmin={true}
              hasSubject={true}
              fields={fields || []}
              sideBarTables={submoduleselectedtablesresults || []}
            />
          </Typography>
        </TabPanel>
        {hasExternalNotify && (
          <TabPanel className=" col-sm-12 p-1" value={tabValue} index={1}>
            <Typography>
              <Template
                ref={templateFormRef}
                moduleId={props.extraProps.SubModuleKey}
                sitePermitTypeId={props.extraProps.SitePermitTypeId}
                handleTemplateId={handleExternalTemplateId}
                templateId={externalTemplateId}
                isadmin={true}
                hasSubject={true}
                fields={fields || []}
                sideBarTables={submoduleselectedtablesresults || []}
              />
            </Typography>
          </TabPanel>
        )}
      </Paper>
    </Fragment>
  );
};

const mapActions = (dispatch) => bindActionCreators({ snackbarMessage }, dispatch);

export default withRouter(connect(null, mapActions)(NSTemplate));
